var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEyeShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2211 30.6647C45.3882 36.8057 38.4731 44.4016 27.9981 44.4016C17.5231 44.4016 10.608 36.8057 6.7751 30.6647C5.73903 29.0047 5.73903 26.9984 6.7751 25.3384C10.608 19.1974 17.5231 11.6016 27.9981 11.6016C38.4731 11.6016 45.3882 19.1974 49.2211 25.3384C50.2572 26.9984 50.2572 29.0047 49.2211 30.6647ZM54.311 22.1616C56.5605 25.7657 56.5605 30.2375 54.311 33.8416C50.1686 40.4785 41.6864 50.4016 27.9981 50.4016C14.3098 50.4016 5.82758 40.4785 1.68515 33.8416C-0.564322 30.2375 -0.56432 25.7657 1.68515 22.1616C5.82758 15.5246 14.3098 5.60156 27.9981 5.60156C41.6864 5.60156 50.1686 15.5246 54.311 22.1616ZM22.7977 28.0008C22.7977 25.1246 25.1215 22.8008 27.9977 22.8008C30.8738 22.8008 33.1977 25.1246 33.1977 28.0008C33.1977 30.8769 30.8738 33.2008 27.9977 33.2008C25.1264 33.2008 22.7977 30.8743 22.7977 28.0008ZM16.7977 28.0008C16.7977 21.8109 21.8078 16.8008 27.9977 16.8008C34.1876 16.8008 39.1977 21.8109 39.1977 28.0008C39.1977 34.1906 34.1876 39.2008 27.9977 39.2008C21.8153 39.2008 16.7977 34.1906 16.7977 28.0008Z",
    fill: "#38A6D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeShow);
export default __webpack_public_path__ + "static/media/icon-eye-show.9ef49ddd1c8debc718d2b91e2b010fbd.svg";
export { ForwardRef as ReactComponent };